<div class="container-fluid">
    <div class="row justify-content-center">

        <div class="col-12">
            <div class="card my-5 text-center custom-shadow">
                <div class="card-header color-secundario-fondo text-white custom-shadow custom-card-header py-3">
                    <h4>{{titulo}}</h4>
                </div>

                <div class="card-body p-0">

                    <div class="container-fluid text-center my-5 color-primario-letra"
                        *ngIf="(certificaciones.length === 0)">
                        <h5>El usuario no posee certificaciones</h5>
                    </div>


                    <div class="container-fluid p-0" *ngIf="(certificaciones.length > 0)">

                        <div class="table-responsive">

                            <table class="table table-borderless my-5">

                                <thead class="color-alternativo-fondo">
                                    <tr>
                                        <th class="py-3" *ngFor="let e of encabezados">{{e}}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let cer of certificaciones">
                                        <td class="py-3">{{cer.fac_codigo}}</td>
                                        <td class="py-3">{{cer.per_ano}} - {{cer.per_periodo}}</td>
                                        <td class="py-3">{{cer.fac_fecha | date: 'dd-MM-yyyy hh:mm a'}}</td>
                                        <td class="py-3">{{cer.fac_total_abonos| currency}}</td>
                                        <td class="py-3">{{cer.lit_nombre}}</td>
                                        <td class="py-3">
                                            <button class="btn btn-primary color-primario-fondo shadow"
                                            *ngIf="perfil?.gru_nombre?.toLocaleUpperCase() != 'GRADUADO'"
                                                [routerLink]="['/menu-opciones-certificados', cer.liq_codigo, cer.fac_codigo, cer.lit_codigo]">Generar 
                                            </button>
                                        
                                            
                                            <button (click)="onClickGenerarFichaAcademicaGraduado(cer)"
                                            *ngIf="perfil?.gru_nombre?.toLocaleUpperCase() == 'GRADUADO'"
                                                class="btn btn-primary color-secundario-fondo text-white mt-2"
                                                data-bs-toggle="tooltip" data-bs-placement="left"
                                                title="Generar ficha académica">Generar ficha {{perfil?.gru_nombre}}
                                            </button>
                                            
                                        


                                            
                                            <!-- <button class="btn btn-primary color-primario-secundario shadow"
                                                *ngIf="(cer.cer_estado === 1)" (click)="visualizarDocumento(cer)">Visualizar</button> -->
                                            <!-- <span *ngIf="(cer.cer_estado === null)">Sin acción para realizar</span> -->
                                        </td>
                                    </tr>

                                </tbody>

                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #popupVistaPrevia let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Vista Previa</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ngx-extended-pdf-viewer [base64Src]="certificadoInfo.documentoVistaPrevia" [useBrowserLocale]="true" [enablePrint]="false"
            [showOpenFileButton]="false" [showDownloadButton]="false" [showPropertiesButton]="false"
            [showBookmarkButton]="false" [showPropertiesButton]="false" [showSecondaryToolbarButton]="false"
            height="71vh" [zoom]="'100%'" backgroundColor="#e8e8ef"></ngx-extended-pdf-viewer>
    </div>
</ng-template>